import React from 'react';
import AudioControl from '../../../common/components/AudioControl';
import AudioControlPlayButton from '../../../common/components/AudioControlPlayButton';
import AudioControlSeekbar from '../../../common/components/AudioControlSeekbar';

/**
 * リリーストラック情報（タイトル）
 */
export default function MusicAlbumInfoReleaseTrackTitleView({
  trackNo,
  music,
} : {
  trackNo: number,
  music: {
    title: string,
    title_kana: string,
    title_en: string,
    version: string,
    version_kana: string,
    version_en: string,
    source_audio_url: string,
    music_featuring_artists: {
      name: string,
    }[],
  },
}) {
  const version = music.version || '';
  const compoundFeaturingArtistName = music.music_featuring_artists.map((musicFeaturingArtist) => musicFeaturingArtist.name).join(', ');
  const longTitleSuffix =
    (version.length > 0 ? `(${version}) ` : '') +
    (compoundFeaturingArtistName.length > 0 ? `(feat. ${compoundFeaturingArtistName})` : '');
  const longTitleKana = `${music.title_kana}${(music.version_kana || '').length > 0 ? ` (${music.version_kana})` : ''}`;
  const longTitleEn = `${music.title_en}${(music.version_en || '').length > 0 ? ` (${music.version_en})` : ''}`;

  return (
    <>
      <AudioControl url={music.source_audio_url}>
        <AudioControlPlayButton />
        <div className="song_info">
          <p className="song_title">
            <span className="ttl">{`${trackNo}. ${music.title}`}</span>
            {longTitleSuffix}
          </p>
          <AudioControlSeekbar />
        </div>
      </AudioControl>
      <ul className="song_details">
        <li>
          <span>ひらがな：</span>
          {longTitleKana}
        </li>
        <li>
          <span>英語：</span>
          {longTitleEn}
        </li>
      </ul>
    </>
  );
}

